<template>
  <div></div>
</template>
<script>
export default {
  name: 'buy-online-ecommerce-btn-show-hide',
  mounted() {
    const windowHeight = window.innerHeight;
    if (document.getElementById('stickybarscroll')) {
      document.getElementById('stickybarscroll').style.display = 'none';
      window.onscroll = () => {
        if (
          document.body.scrollTop > windowHeight ||
          document.documentElement.scrollTop > windowHeight
        ) {
          document.getElementById('stickybarscroll').style.display = 'block';
        } else {
          document.getElementById('stickybarscroll').style.display = 'none';
        }
      };
    }
  },
};
</script>
